import { CalendarHeart, Cake, Plane, Stethoscope, Bell, Sparkles } from "lucide-react";

// Momentos do casal no calendário (não financeiros)
export const EVENT_KINDS = {
  aniversario: { label: "data especial", color: "#C2417A", icon: Cake, hint: "aniversários, dia que se conheceram, casamento" },
  encontro: { label: "encontro", color: "#E06A55", icon: CalendarHeart, hint: "jantar, cinema, um tempo só nosso" },
  viagem: { label: "viagem", color: "#1D6A73", icon: Plane, hint: "fim de semana fora, férias" },
  compromisso: { label: "compromisso", color: "#4A3B37", icon: Stethoscope, hint: "consulta, família, trabalho" },
  lembrete: { label: "lembrete", color: "#C98A3B", icon: Bell, hint: "não esquecer de…" },
  momento: { label: "momento", color: "#8A7B5C", icon: Sparkles, hint: "qualquer coisa que importa pra nós" },
};

export const EVENT_KIND_OPTIONS = Object.entries(EVENT_KINDS).map(([value, k]) => ({ value, label: k.label }));

export const REPEATS = [
  { value: "none", label: "uma vez" },
  { value: "weekly", label: "toda semana" },
  { value: "monthly", label: "todo mês" },
  { value: "yearly", label: "todo ano" },
];

export const REMIND_OPTIONS = [
  { value: 0, label: "no dia" },
  { value: 1, label: "1 dia antes" },
  { value: 3, label: "3 dias antes" },
  { value: 7, label: "1 semana antes" },
  { value: 14, label: "2 semanas antes" },
];

export const isCoupleKind = (kind) => kind in EVENT_KINDS;

export const whenLabel = (daysLeft) => {
  if (daysLeft == null) return "";
  if (daysLeft < 0) return daysLeft === -1 ? "foi ontem" : `há ${-daysLeft} dias`;
  if (daysLeft === 0) return "hoje";
  if (daysLeft === 1) return "amanhã";
  if (daysLeft < 30) return `em ${daysLeft} dias`;
  const months = Math.round(daysLeft / 30);
  return months === 1 ? "em 1 mês" : `em ${months} meses`;
};

export const yearsLabel = (years) => (years ? (years === 1 ? "faz 1 ano" : `faz ${years} anos`) : "");

export const longDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  const date = new Date(y, m - 1, d);
  return date.toLocaleDateString("pt-BR", { weekday: "long", day: "numeric", month: "long" });
};
